module.exports = __webpack_public_path__ + "static/media/tomLo.a9611b1d.wav";